(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 47.99em)';
  var SAFETY_FACTOR = 0.97;
  var MIN_FONT_SIZE_REM = 1.2;
  var MAX_ITERATIONS = 24;

  var BUTTON_SELECTORS = '[data-button-fit-mobile="true"]';

  var mobileMedia = window.matchMedia(MOBILE_QUERY);
  var resizeTimer = null;

  function getTextElement(button) {
    var textEl = button.querySelector('.button__text');
    return textEl || button;
  }

  function getMinFontSizePx() {
    var rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 16;
    return MIN_FONT_SIZE_REM * rootFontSize;
  }

  function getAvailableWidth(button) {
    var buttonStyle = window.getComputedStyle(button);
    var paddingX =
      parseFloat(buttonStyle.paddingLeft) + parseFloat(buttonStyle.paddingRight);
    var borderX =
      parseFloat(buttonStyle.borderLeftWidth) + parseFloat(buttonStyle.borderRightWidth);
    var gap = parseFloat(buttonStyle.gap) || 0;
    var icon = button.querySelector('.icon');

    if (icon) {
      return button.clientWidth - paddingX - borderX - icon.getBoundingClientRect().width - gap;
    }

    return button.clientWidth - paddingX - borderX;
  }

  function resetButton(button) {
    var textEl = getTextElement(button);
    if (!textEl) return;

    textEl.style.fontSize = '';
    textEl.style.whiteSpace = '';
    delete textEl.dataset.fitBaseline;
  }

  function fitButton(button) {
    var textEl = getTextElement(button);
    if (!textEl || !textEl.textContent || !textEl.textContent.trim()) return;

    if (!textEl.dataset.fitBaseline) {
      textEl.dataset.fitBaseline = window.getComputedStyle(textEl).fontSize;
    }

    textEl.style.fontSize = textEl.dataset.fitBaseline;
    textEl.style.whiteSpace = 'nowrap';

    var availableWidth = getAvailableWidth(button);
    if (availableWidth <= 0) return;

    var fontSize = parseFloat(window.getComputedStyle(textEl).fontSize);
    var minFontSize = getMinFontSizePx();
    var iterations = 0;

    while (textEl.scrollWidth > availableWidth && fontSize > minFontSize && iterations < MAX_ITERATIONS) {
      var ratio = (availableWidth / textEl.scrollWidth) * SAFETY_FACTOR;
      fontSize = Math.max(minFontSize, fontSize * ratio);
      textEl.style.fontSize = fontSize + 'px';
      iterations++;
    }
  }

  function getButtons() {
    return Array.prototype.slice.call(document.querySelectorAll(BUTTON_SELECTORS));
  }

  function resetAll() {
    getButtons().forEach(resetButton);
  }

  function fitAll() {
    if (!mobileMedia.matches) {
      resetAll();
      return;
    }

    getButtons().forEach(fitButton);
  }

  function scheduleFit() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(fitAll, 100);
  }

  function observeButtons() {
    if (!('MutationObserver' in window) || !document.body) return;

    var observer = new MutationObserver(function () {
      scheduleFit();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    fitAll();

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleFit);
    }

    mobileMedia.addEventListener('change', fitAll);
    window.addEventListener('resize', scheduleFit);
    window.addEventListener('orientationchange', scheduleFit);
    window.addEventListener('load', scheduleFit);
    observeButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
